// Path: sec-parser/client/src/pages/ChangePasswordPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Card, Input, Button, Typography, Alert, Space } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { changePassword } from "../services/api";
import { clearAuth } from "../store";

const { Title, Text } = Typography;

export default function ChangePasswordPage() {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const [form, setForm]     = useState({ currentPassword: "", newPassword: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (form.newPassword !== form.confirm) {
      setError("New passwords do not match");
      return;
    }
    if (form.newPassword.length < 8) {
      setError("New password must be at least 8 characters");
      return;
    }
    setError(null);
    setLoading(true);
    try {
      await changePassword({
        currentPassword: form.currentPassword,
        newPassword:     form.newPassword,
      });
      setSuccess(true);
      setTimeout(() => {
        dispatch(clearAuth());
        navigate("/login", { replace: true });
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || "Failed to change password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 440, margin: "60px auto" }}>
      <Card>
        <Title level={4} style={{ color: "#1A3C5E", marginBottom: 24 }}>
          <LockOutlined style={{ marginRight: 8 }} />Change Password
        </Title>

        <Space direction="vertical" size={14} style={{ width: "100%" }}>
          {error   && <Alert type="error"   message={error}                              showIcon />}
          {success && <Alert type="success" message="Password changed. Redirecting to login…" showIcon />}

          <div>
            <Text strong>Current Password</Text>
            <Input.Password
              value={form.currentPassword}
              onChange={(e) => setForm({ ...form, currentPassword: e.target.value })}
              style={{ marginTop: 4 }}
            />
          </div>
          <div>
            <Text strong>New Password</Text>
            <Input.Password
              value={form.newPassword}
              onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
              placeholder="Min. 8 characters"
              style={{ marginTop: 4 }}
            />
          </div>
          <div>
            <Text strong>Confirm New Password</Text>
            <Input.Password
              value={form.confirm}
              onChange={(e) => setForm({ ...form, confirm: e.target.value })}
              onPressEnter={handleSubmit}
              style={{ marginTop: 4 }}
            />
          </div>

          <Button
            type="primary"
            block
            loading={loading}
            onClick={handleSubmit}
            disabled={success}
            style={{ background: "#1A3C5E", marginTop: 8 }}
          >
            Update Password
          </Button>
          <Button block onClick={() => navigate(-1)}>Cancel</Button>
        </Space>
      </Card>
    </div>
  );
}